export abstract class StorageService {
  abstract delete(key: string): void;
  abstract get(key: string): string | null;
  abstract set(key: string, data: string): void;
}
